/* import __COLOCATED_TEMPLATE__ from './providers.hbs.js'; */
var _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { getOwner } from '@ember/owner';
let _class = (_class2 = class _class2 extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "api", _descriptor, this);
    _initializerDefineProperty(this, "vagrantContext", _descriptor2, this);
    _initializerDefineProperty(this, "providerDuplicateness", _descriptor3, this);
    _initializerDefineProperty(this, "noHostedArchitecture", _descriptor4, this);
  }
  get registryId() {
    return this.vagrantContext.registry?.name;
  }
  *createProviders(ev) {
    ev.preventDefault();
    if (!this.registryId) return;
    const registryId = this.registryId;

    // First, remove duplicates from this.args.providers.providers
    this.args.providers.dedupe();

    // Make sure the providers set has registry, box, and version info
    this.args.providers.setVersion(registryId, this.args.box.name ?? '', this.args.version.name ?? '');

    // Collect the providers to save and group them by provider name
    const providersToSave = {};
    this.args.providers.providers.forEach(p => {
      // Check arguments
      p.missingArchitecture = false;
      p.missingHostedFile = false;
      if (!p.architecture) {
        p.missingArchitecture = true;
      }
      if (p.isHosted && !p.file) {
        p.missingHostedFile = true;
      }
      if (!p.name || p.provider != null || p.missingArchitecture || p.missingHostedFile) return;
      if (!providersToSave[p.name]) {
        providersToSave[p.name] = [];
      }
      providersToSave[p.name]?.push(p);
    });
    const provMultiError = {};
    const archMultiError = {};

    // Then, in parallel attempt to create providers
    const promises = Object.entries(providersToSave).map(async ([providerName, providers]) => {
      try {
        let provider;
        try {
          // Attempt to read the provider for providers that already exist
          const resp = await this.api.vagrant.registryServiceApi.readProvider(registryId, this.args.box.name ?? '', this.args.version.name ?? '', providerName);
          if (resp.provider) {
            provider = resp.provider;
          }
        } catch (err) {
          // If the error is a not found response continue on,
          // otherwise throw the error.
          if (err) {
            const errResp = err;
            if (errResp.status != 404) {
              provMultiError[providerName] = err;
            }
          } else {
            provMultiError[providerName] = err;
          }

          // Now attempt to create the provider.
          const resp = await this.api.vagrant.registryServiceApi.createProvider(registryId, this.args.box.name ?? '', this.args.version.name ?? '', {
            name: providerName
          });
          if (resp.provider) {
            provider = resp.provider;
          }
        }

        // Now that the provider has been created, create
        // all the architectures defined for it.
        if (provider) {
          const archPromises = providers.map(async p => {
            const archPromise = this.api.vagrant.registryServiceApi.createArchitecture(registryId, this.args.box.name ?? '', this.args.version.name ?? '', provider?.name ?? '', p.serializeArchitecture());
            try {
              const archResp = await archPromise;
              if (archResp.architecture) {
                p.provider = provider;
              }
            } catch (err) {
              const archName = providerName + '/' + p.serializeArchitecture().architectureType;
              archMultiError[archName] = err;
            }
          });
          await Promise.all(archPromises);
        }
      } catch (err) {
        provMultiError[providerName] = err;
      }
    });
    yield Promise.all(promises);
    this.displayMultiErrors(provMultiError, 'provider');
    this.displayMultiErrors(archMultiError, 'architecture');

    // Then, if everything succeeds, proceed, if not, stay (cards take care of themselves based on responses)
    if (!this.args.providers.providers.find(p => p.provider == null)) {
      this.args.onCreate?.(this.args.providers);
    }
  }
  dedupe() {
    // Cache keys to avoid an inner-loop
    const memo = {};
    this.providerDuplicateness = this.args.providers.providers.map(p => {
      // Skip incomplete providers
      if (!p.name || !p.architecture) return false;
      const key = `${p.name}::${p.architecture}`;
      if (memo[key]) return true;
      memo[key] = true;
      return false;
    });
  }
  displayMultiErrors(errObj, objectType) {
    const owner = getOwner(this);
    const flashMessages = owner?.lookup('service:flash-messages');
    const msgPrefix = 'Could not create ' + objectType + ' ';
    for (const k in errObj) {
      let errVal;
      // confirm value is Response type and display flash
      if (errObj[k] != undefined && errObj[k] instanceof Response) {
        const e = errObj[k];
        errVal = e.json();

        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        errVal.then(value => {
          const msg = msgPrefix + k + '\n' + value.message;
          flashMessages.error(msg);
        });
      }

      // confirm value is Error type and display flash
      if (errObj[k] != undefined && errObj[k] instanceof Error) {
        const e = errObj[k];
        errVal = e.toString();
        const msg = msgPrefix + k + '\n' + errVal;
        flashMessages.error(msg);
      }
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "api", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "vagrantContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "providerDuplicateness", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "noHostedArchitecture", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "createProviders", [task], Object.getOwnPropertyDescriptor(_class2.prototype, "createProviders"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "dedupe", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "dedupe"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "displayMultiErrors", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "displayMultiErrors"), _class2.prototype), _class2);
export { _class as default };